export const OUTLOOK_READ_MAIL = 'OUTLOOK_READ_MAIL'
export const OUTLOOK_SEND_MAIL = 'OUTLOOK_SEND_MAIL'
export const OUTLOOK_CONFIG = 'OUTLOOK_CONFIG'
export const ACCESS_TOKEN_SUCCESS = 'ACCESS_TOKEN_SUCCESS'

export const IMAP_READ_MAIL = "IMAP_READ_MAIL"
export const SAVE_ATTACHMENT = "SAVE_ATTACHMENT"

export const POP3_READ_MAIL = "POP3_READ_MAIL"

export const OUTLOOK_GET_MAIL = "OUTLOOK_GET_MAIL"
export const SEND_OUTLOOK_MAIL = "SEND_OUTLOOK_MAIL"

export const SEND_SMTP_MAIL = "SEND_SMTP_MAIL"